import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showLoading, showAlert } from "../Actions/GeneralActions";
// import { headers } from "../../Utils";
import {
  MyAdvertisement,
  deleteAdvertisement,
} from "../Actions/AdvertisementActions";
import { headers } from "../../utills";

export const AdvertisementMiddleware = {
  createAdvertisement: (data) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("title", data.title);
          formData.append("type", data.type);
          if (data.text) {
            formData.append("text", data.text);
          }
          formData.append("image", data.document);

          const response = await Axios.post(
            Apis.createAdvertisement,
            formData,
            await headers.config()
          );

          if (response?.status == 200) {
            dispatch(
              showAlert({
                title: "Advertisement",
                message: response?.data?.message,
                type: "Success",
                status: response?.response?.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Advertisement",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateAdvertisement: (data) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("id", data.id);
          formData.append("title", data.title);
          formData.append("type", data.type);
          if (data.text) {
            formData.append("text", data.text);
          }
          if (data?.document) {
            formData.append("image", data.document);
          }

          const response = await Axios.post(
            Apis.updateAdvertisement,
            formData,
            await headers.config()
          );

          if (response?.status == 200) {
            dispatch(MyAdvertisement(response.data.data));
            dispatch(
              showAlert({
                title: "Advertisement",
                message: response?.data?.message,
                type: "Success",
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Advertisement",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getAdvertisement: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const response = await Axios.get(
            Apis.getAdvertisement,
            await headers.config()
          );
          if (response?.status == 200) {
            dispatch(hideLoading())
            dispatch(MyAdvertisement(response.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(hideLoading())
          reject(error);
          dispatch(
            showAlert({
              title: "Advertisement",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  deleteAdvertisement: (id, index) => {
    return (dispatch) => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", id);
          const response = await Axios.post(
            Apis.deleteAdvertisement,
            formData,
            await headers.config()
          );
          if (response?.status == 200) {
            dispatch(hideLoading())
            dispatch(deleteAdvertisement(index));
            dispatch(
              showAlert({
                title: "Advertisement",
                message: response?.data?.message,
                type: "Success",
                status: response?.data?.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          dispatch(hideLoading())
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "Advertisement",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
};
